import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Employee } from '../../customer/customer.model';
import { ModalService } from 'src/app/services/modal.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ResourceAccessService } from '../resource-access.service';
import { DepartmentService } from 'src/app/services/department.service';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-resource-access-users',
    templateUrl: './resource-access-users.component.html',
    styleUrl: './resource-access-users.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule]
})
export class ResourceAccessUsersComponent {

  isBusy: boolean = false;
  employees: Employee[] = [];
  filterEmployees: Employee[] = [];
  
  choosenEmployee: Employee = {} as Employee;

  statusMessage: string = 'Indlæser medarbejdere'

  searchText: string = '';
  constructor(
    public modalService: ModalService,
    public activeModal: NgbActiveModal,
    private resourceAccessService: ResourceAccessService,
    private departmentService: DepartmentService,
    
  ) { }

  async ngOnInit(): Promise<void> {
    this.statusMessage = 'Indlæser medarbejdere';
    this.isBusy = true;
    this.employees = await this.resourceAccessService.getEmployees(this.departmentService.getDepartment().code);
    this.search();
    this.isBusy = false;
  }

  search()
  {
    if (!this.searchText.trim()) 
    { 
      this.filterEmployees = [...this.employees];
      return; 
    }

    this.filterEmployees = this.employees.filter(
      x=> x.name.toString().toLowerCase().indexOf(this.searchText.toLocaleLowerCase()) > -1
      || x.departmentCode.toLowerCase().startsWith(this.searchText.toLocaleLowerCase()) 
      || x.departmentName.toLowerCase().startsWith(this.searchText.toLocaleLowerCase())
      || x.email.toLowerCase().startsWith(this.searchText.toLocaleLowerCase())
    );
    
  }   

  chooseEmployee(employee: Employee)
  {
    this.choosenEmployee = employee;
  }

  async chooseAndAdd()
  {
    this.statusMessage = "Opretter adgang til " + this.choosenEmployee.name;  
    this.isBusy = true;
    const addedUser = await this.resourceAccessService.AddUser(this.choosenEmployee.id);
    this.activeModal.close(this.choosenEmployee); //returnerer den valgte ressource
  }

}
